import { searchCep, type CepPromiseResponse } from '@/libs';
import { logger, stripLocationQualifier } from '@/utils';

export type AddressServiceResponse = {
  zipCode: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
};

/**
 * Searches for address information from a CEP
 *
 * @param cep - CEP in string format (with or without formatting)
 * @returns Promise with the formatted address data
 * @throws Error if the CEP is invalid or not found
 */
export const searchAddressByCep = async (
  cep: string,
): Promise<AddressServiceResponse> => {
  try {
    const result: CepPromiseResponse = await searchCep(cep);

    return {
      zipCode: result.cep,
      street: stripLocationQualifier(result.street || ''),
      neighborhood: stripLocationQualifier(result.neighborhood || ''),
      city: result.city || '',
      state: result.state || '',
    };
  } catch (error) {
    logger.error('Error searching address by CEP:', error);

    if (error instanceof Error) {
      throw new Error(`Error searching CEP: ${error.message}`);
    }

    throw new Error('Unknown error searching CEP');
  }
};
